// src/lib/constants.ts

export const MINUTES_PER_CREDIT = 0.5;
export const CREDITS_PER_MINUTE = 1 / MINUTES_PER_CREDIT;
export const BASE_CREDITS = 5;
export const BASE_MINUTES = 2.5;
export const QUIZ_CREDITS = 10;
export const FREE_CREDITS = 100;

export const USE_VERBOSE_LOGGING = false;

// Upload limits
export const MAX_DOCUMENT_SIZE_BYTES = 100 * 1024 * 1024; // 100MB
export const MAX_DOCUMENT_SIZE_MB = MAX_DOCUMENT_SIZE_BYTES / (1024 * 1024);

export interface CreditTier {
  id: string;
  credits: number;
  cost: number;
}

export const CREDIT_PACKAGES: CreditTier[] = [
  { id: "1", credits: 100, cost: 10 },
  { id: "2", credits: 300, cost: 25 },
  { id: "3", credits: 700, cost: 50 },
];

export const calculateBasePrice = (credits: number): number => {
  const basePackage = CREDIT_PACKAGES[0];
  return Number(((credits / basePackage.credits) * basePackage.cost).toFixed(2));
};

export const calculateVolumeDiscount = (basePrice: number, actualPrice: number): number => {
  return Number((((basePrice - actualPrice) / basePrice) * 100).toFixed(2));
};

export const roundToTwoDecimals = (value: number): number => {
  return Number(value.toFixed(2));
};
